import { PartialFields } from 'app/models/general';
import React from 'react';

import MButtonView from './MButton.view';

type Props = {
  className?: string;
  type: JSX.IntrinsicElements['button']['type'];
  disabled?: boolean;
  onClick?: () => void;
};

const MButton: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MButtonView className={props.className} type={props.type} onClick={props.onClick} disabled={props.disabled}>
      {props.children}
    </MButtonView>
  );
};

MButton.displayName = 'MButton';
MButton.defaultProps = {
  type: 'button',
};

export default MButton as React.FC<PartialFields<Props, 'type'>>;
